module.exports = __webpack_public_path__ + "static/media/ansiedad.aae276f8.svg";